import accounting from './locales/en-IN/accounting.json';
import auth from './locales/en-IN/auth.json';
import bootstrap from './locales/en-IN/bootstrap.json';
import catalogBanners from './locales/en-IN/catalogBanners.json';
import catalogKits from './locales/en-IN/catalogKits.json';
import brand from './locales/en-IN/brand.json';
import cashCod from './locales/en-IN/cashCod.json';
import catalog from './locales/en-IN/catalog.json';
import category from './locales/en-IN/category.json';
import common from './locales/en-IN/common.json';
import admins from './locales/en-IN/admins.json';
import coupons from './locales/en-IN/coupons.json';
import customers from './locales/en-IN/customers.json';
import deliveryCharges from './locales/en-IN/deliveryCharges.json';
import promotions from './locales/en-IN/promotions.json';
import deliveryRiders from './locales/en-IN/deliveryRiders.json';
import employees from './locales/en-IN/employees.json';
import home from './locales/en-IN/home.json';
import inventory from './locales/en-IN/inventory.json';
import offlineOrders from './locales/en-IN/offlineOrders.json';
import orders from './locales/en-IN/orders.json';
import refunds from './locales/en-IN/refunds.json';
import riders from './locales/en-IN/riders.json';
import product from './locales/en-IN/product.json';
import shell from './locales/en-IN/shell.json';
import stores from './locales/en-IN/stores.json';

/**
 * Static resource map — bundled with the app. We don't load locale files over
 * HTTP in v1 (ByQuick is India-only, single locale `en-IN`). If/when more
 * locales are added, swap this for `i18next-http-backend` or code-split imports.
 *
 * Each feature that owns a namespace appends its JSON here to keep the module
 * graph explicit (no dynamic `require.context`-style magic).
 */
export const defaultNS = 'common';

export const resources = {
  'en-IN': {
    common,
    catalogBanners,
    catalogKits,
    bootstrap,
    auth,
    admins,
    coupons,
    deliveryCharges,
    promotions,
    customers,
    deliveryRiders,
    employees,
    home,
    inventory,
    riders,
    refunds,
    shell,
    brand,
    category,
    product,
    accounting,
    cashCod,
    catalog,
    offlineOrders,
    orders,
    stores,
  },
} as const;

export type AppLocale = keyof typeof resources;
export type AppNamespace = keyof (typeof resources)['en-IN'];
